import { createStore, compose } from 'redux';
import Thunk from 'redux-thunk';
import {
  MiddlewareRegistry,
  PersistenceRegistry,
  ReducerRegistry,
  StateListenerRegistry
} from './modules/base/redux';
import { composeWithDevTools } from '@redux-devtools/extension';

// const middlewares = rootMiddleware;

// const sagaMiddleware = createSagaMiddleware();
// middlewares.push(sagaMiddleware);
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const middleware = composeEnhancers(
//   applyMiddleware(...middlewares, thunkMiddleware)
// );
// const store = createStore(rootReducer, middleware);
// sagaMiddleware.run(rootSaga);

// Create combined reducer from all reducers in ReducerRegistry.
const reducer = ReducerRegistry.combineReducers();

// Apply all registered middleware from the MiddlewareRegistry and
// additional 3rd party middleware:
// - Thunk - allows us to dispatch async actions easily. For more info
// @see https://github.com/gaearon/redux-thunk.
const middleware = MiddlewareRegistry.applyMiddleware(Thunk);
const composeEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ||
  compose ||
  composeWithDevTools();
const store = createStore(
  reducer,
  PersistenceRegistry.getPersistedState(),
  composeEnhancers(middleware)
);
StateListenerRegistry.subscribe(store);

export default store;
